import { FormattedMessage } from 'react-intl';
import { INPUT_TYPES } from 'views/Widgets/Inputs/ValidatedInputTypes';

export interface SurveyQuestionDefinition {
  type: string;
  label: string;
  helperText?: string;
  options?: Array<{ id: string; name: string }>;
  objects?: Array<{ name: string; value: number; helperText?: string }>;
}

export const noAnswerElement = (
  <span className="text-muted fst-italic">
    <FormattedMessage
      id="app.views.custom_surveys.survey_response_view.no_answer"
      defaultMessage="No answer"
    />
  </span>
);

// Unwrap the per-type answer envelope (e.g. {rating}, {text}, {value}, {date})
// into the scalar value parseAndFormatQuestionResponse expects.
export const extractSurveyAnswerResponse = (
  type: string,
  answerJson: Record<string, unknown> | undefined
): unknown => {
  if (!answerJson) return undefined;
  const questionType = type.toUpperCase();
  if (questionType === INPUT_TYPES.STAR_RATING) return answerJson.rating;
  if (
    questionType === INPUT_TYPES.TEXTAREA ||
    questionType === INPUT_TYPES.RICH_TEXT_EDITOR
  ) {
    return answerJson.text;
  }
  if (questionType === INPUT_TYPES.DATE_PICKER) return answerJson.date;
  return answerJson.value ?? answerJson.text ?? answerJson.rating;
};
